import { useNode } from './node'
import type { Tag } from '@deepcloud/api-deep-box'

export function useNodeTags() {
  const { getNodeById } = useNode()

  // UPDATE NODE TAGS
  function updateNodeTags(payload: { nodeId: string; tags: Tag[] }) {
    const node = getNodeById(payload.nodeId)
    if (node) {
      node.tags = payload.tags
    }
  }

  return {
    updateNodeTags,
  }
}
